import { Input } from 'antd';
import { FC, ChangeEventHandler, ReactNode } from 'react';
import classnames from 'classnames';

import styles from './index.module.scss';

type TextFieldProps = {
	onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
	label: string;
	value?: string;
	type?: string;
	id?: string;
	suffix?: ReactNode;
};

export const TextField: FC<TextFieldProps> = ({
	label,
	value,
	onChange,
	type = 'text',
	id,
	suffix,
}) => {
	return (
		<div className={styles.root}>
			<Input
				id={id}
				value={value}
				className={`${value && 'filled'}`}
				onChange={onChange}
				onWheel={(event) => {
					if (type === 'number') {
						event.currentTarget.blur();
					}
				}}
				type={type}
				suffix={suffix}
				placeholder={label}
			/>
			<label
				htmlFor={id}
				className={classnames('float-label', styles.label)}
			>
				{label}
			</label>
		</div>
	);
};
